import {NgModule} from '@angular/core';
import {PageCommonModule} from '../shared/page-common.module';
import {FileUploaderModule} from '../../components/files/file-uploader/file-uploader.module';
import {OcrService} from '../../components/ocr/ocr.service';
import {FilesUploadPageComponent} from './upload/files-upload-page.component';
import {FileListModule} from '../../components/files/file-list/file-list.module';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {NgbDatepickerModule, NgbTooltipModule, NgbTabsetModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '../../components/forms/forms.module';
import {FilesViewPageComponent} from './view/files-view-page.component';
import {FilesWorkPageComponent} from './work/files-work-page.component';
import {FilesEducationPageComponent} from './education/files-education-page.component';
import {AccordionModule} from '../../components/accordion/accordion.module';

@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        NgbDatepickerModule,
        NgbTooltipModule,
        NgbTabsetModule,
        FileListModule,
        FileUploaderModule,
        AccordionModule],
    declarations: [FilesUploadPageComponent, FilesViewPageComponent, FilesWorkPageComponent, FilesEducationPageComponent],
    providers: [OcrService]
})
export class ResumePagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/resume-pages.module.ts